import { FormControl } from 'baseui/form-control'
import { formControlOverrides } from '../styled-components'

type SDFormControlProps = {
  hidden?: boolean
  children: React.ReactNode
  [key: string]: any
}

const SDFormControl = ({ hidden, children, ...props }: SDFormControlProps) => {
  if (hidden) return null

  return (
    // @ts-ignore
    <FormControl overrides={formControlOverrides} {...props}>
      {children}
    </FormControl>
  )
}

export default SDFormControl
